import BaseModule from "~/vuex/modules/base-module";

let Roles = {...BaseModule};

Roles.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/roles';


    return state;
};
export default Roles;
